import helpers from "./helpers";
import { RestAPI as API } from '@aws-amplify/api-rest';
import { withAuditoryAmplify } from '@auditory/provider/hooks';

const post = (path, data, name) =>
	API.post(name, path, helpers.getBodyAmplify(data));
const get = (name, path, params, headers) =>
	params
    ? API.get(name, path, { queryStringParameters: params, headers })
    : API.get(name, path, { headers });

const getWithHeaders = (name, path, { headers, queryStringParameters }) =>
  API.get(name, path, { headers, queryStringParameters });

const postWitchTrace = (path, data, name, serviceId) =>
	API.post(name, path, helpers.getBody(data, helpers.getLeadsTrace(serviceId)));

const postWitchTraceSoat = (path, data, name, serviceId) =>
	API.post(name, path, helpers.getBodySoat(data, helpers.getLeadsTrace(serviceId)));

const AmplifyApi = async (request) => {
	const req = { ...request };
	try {
		let response;
		if (req.method) {
			switch (req.method) {
				case 'put':
					response = await API.put(req.name, req.path, req.data);
					break;
				default:
					response = await API.post(req.name, req.path, req.data);
					break;
			}
		} else response = await API.post(req.name, req.path, req.data);
		return response;
	} catch (error) {
		throw error;
	}
};

const HTTP_REQUEST = {
  get,
  getWithHeaders,
  post: withAuditoryAmplify('post', post),
  postWitchTrace: withAuditoryAmplify('postWitchTrace', postWitchTrace),
  postWitchTraceSoat: withAuditoryAmplify('postWitchTraceSoat', postWitchTraceSoat),
  AmplifyApi: withAuditoryAmplify('AmplifyApi', AmplifyApi),
};

export default HTTP_REQUEST;
